export default __webpack_public_path__ + "static/media/elif-sosyal.eb82fb08.mp4";